const rankingItems = [
  {
    rank: 1,
    title: '斗破苍穹',
    author: '天蚕土豆 / 任翔',
    type: '玄幻热血',
    hot: '9326万热度',
    desc: '天才少年萧炎创造了家族空前的修炼纪录后遭遇人生低谷，种种打击接踵而至。就在他即将绝望之际，一缕幽魂从他手上的戒指里浮现...',
    icon: 'ri-fire-fill',
  },
  {
    rank: 2,
    title: '一人之下',
    author: '米二',
    type: '都市异能',
    hot: '8754万热度',
    desc: '普通大学生张楚岚在一次意外中卷入了异人的世界，从此开启了充满传奇色彩的人生旅程。',
    icon: 'ri-fire-fill',
  },
  {
    rank: 3,
    title: '完美世界',
    author: '辰东',
    type: '东方玄幻',
    hot: '8123万热度',
    desc: '一粒尘可填海，一根草斩尽日月星辰。石昊在乱世中崛起，以一人之力横推诸天万界。',
    icon: 'ri-fire-fill',
  },
  {
    rank: 4,
    title: '狐妖小红娘',
    author: '小新',
    type: '恋爱奇幻',
    hot: '7658万热度',
    desc: '人与妖之间的爱情故事，通过狐妖小红娘的牵线搭桥，一段段感人至深的缘分就此展开。',
    icon: 'ri-fire-fill',
  },
  {
    rank: 5,
    title: '全职高手',
    author: '蝴蝶蓝 / 常盘勇者',
    type: '游戏竞技',
    hot: '7234万热度',
    desc: '被誉为荣耀教科书级别的顶尖高手叶修，在遭到俱乐部驱逐后，重新投入到他热爱的游戏中。',
    icon: 'ri-fire-fill',
  },
  {
    rank: 6,
    title: '镖人',
    author: '许先哲',
    type: '历史武侠',
    hot: '6891万热度',
    desc: '大业三年，隋王朝风雨飘摇。身手不凡的镖客刀马行走在乱世之中，一诺千金护镖走天涯。',
    icon: 'ri-fire-fill',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门榜单</h2>
          <p className="text-sm text-foreground-500">全网漫画热度排行，看看大家都爱看什么</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-4 md:p-5 flex items-center gap-4 group cursor-pointer hover:scale-[1.01] transition-transform"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-background-200 flex items-center justify-center">
                <span
                  className={`text-lg md:text-xl font-heading ${
                    item.rank <= 3 ? 'text-primary-500' : 'text-foreground-400'
                  }`}
                >
                  {item.rank}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800">{item.title}</h3>
                  <span className="text-xs text-foreground-400">{item.author}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 text-right hidden sm:block">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium">
                  <i className={item.icon}></i>
                  {item.hot}
                </span>
              </div>

              <div className="flex-shrink-0 hidden sm:block">
                <span className="text-xs text-foreground-400 bg-background-200 px-2.5 py-1 rounded-full">{item.type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}